import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBlock } from 'antd-mobile';
import { jumpPathPageByWindow, commonH5Jump, jumpTransferPage } from 'src/utils/jump';
import { inApp } from '@hst/utils';
import { trackHotspotClick } from 'src/pages/marketing/track';
import { useTranslation } from 'react-i18next';
import './index.less';

interface propsType {
	data: {
		backgroundImg: string; // 背景图片
		subs?: [];
	};
	pageStatus: string;
}
const viewportWidth = window.innerWidth > 778 ? 778 : window.innerWidth;
const rate = viewportWidth / 375;
export default (props: propsType) => {
	const searchParams = new URLSearchParams(useLocation().search);
	const { i18n } = useTranslation();
	const lang = i18n.language;
	const { backgroundImg, subs } = props.data;
	const [isError, setIsError] = useState<boolean>(false);

	const onError = () => {
		setIsError(true);
	};

	const btnClick = (data) => {
		const _scnl = searchParams.get('_scnl') || '';
		const pageId = searchParams.get('id') || '';
		const { pageStatus } = props;
		const {
			jumpLink,
			jumpPosition,
			jumpLinkStr,
			jumpParam,
			hotAreaName,
			jumpLinkStrNew,
			jumpParamNew,
		} = data;
		if (pageStatus !== 'normal') {
			return;
		}
		trackHotspotClick(pageId, hotAreaName);
		// 1 下载/唤起APP 2 H5链接 3 原生链接 4 新版原生链接
		switch (jumpLink) {
			case 1:
				if (!inApp()) {
					jumpTransferPage(lang, {
						redirectType: '1',
						redirectValue: { _scnl },
					});
				}
				break;
			case 2:
				jumpPathPageByWindow(jumpPosition, { _scnl });
				break;
			case 3:
				commonH5Jump(jumpLinkStr, { ...JSON.parse(jumpParam), _scnl }, lang);
				break;
			case 4:
				commonH5Jump(jumpLinkStrNew, { ...JSON.parse(jumpParamNew), _scnl }, lang);
				break;
			default:
				break;
		}
	};
	return (
		<div className='base-image'>
			{isError ? (
				<ErrorBlock status='disconnected' title={<span>404</span>} description={null} />
			) : (
				<>
					<img src={backgroundImg} alt={backgroundImg} onError={onError} />
					{subs?.length > 0
						? subs.map((item, index) => {
								const { width, height, top, left } = item;
								const style = {
									width: `${width * rate}px`,
									height: `${height * rate}px`,
									position: 'absolute' as any,
									top: `${top * rate}px`,
									left: `${left * rate}px`,
								};
								return <span key={index} style={style} onClick={() => btnClick(item)}></span>;
							})
						: null}
				</>
			)}
		</div>
	);
};
